import {Assert} from "common/Assert";

export function Scorm2004UIDataAdapter(delegateApi ) {

    Assert.checkArgument( delegateApi );

    // revealing public api
    return {
        getUsername: () => {
            return delegateApi.TTGetValue( null, "cmi.learner_name" );
        },
        getScore: ( id ) => {
            return delegateApi.TTGetValue( id, "cmi.score.raw" ) * 100;
        },
        getStatus: ( id ) => {
            return delegateApi.TTGetValue( id, "cmi.completion_status" );
        },
        getLocation: () => ( id ) => {
            return delegateApi.TTGetValue( id, "cmi.location" );
        },
        getStorageType: () => "scorm2004"
    };
}
